import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TopBar from "@/components/TopBar";
import BackButton from "@/components/BackButton";
import api from "@/lib/api";
import { Eye, Heart, Bookmark, Video, TrendingUp } from "lucide-react";

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/users/me/analytics").then(r => setData(r.data)); }, []);
  if (!data) return <div className="min-h-screen"><TopBar subtitle="Analytics"/><p className="text-zinc-400 text-sm p-6">Loading…</p></div>;

  const cards = [
    { label: "Profile views", value: data.profile_views, icon: Eye, color: "text-blue-400" },
    { label: "Video views", value: data.total_views, icon: TrendingUp, color: "text-emerald-400" },
    { label: "Total likes", value: data.total_likes, icon: Heart, color: "text-pink-400" },
    { label: "Saves", value: data.total_saves, icon: Bookmark, color: "text-amber-400" },
    { label: "Performances", value: data.videos_count, icon: Video, color: "text-[#FCA5A5]" },
  ];

  return (
    <div data-testid="analytics-page" className="min-h-screen pb-24">
      <TopBar subtitle="Analytics"/>
      <div className="max-w-2xl mx-auto px-4 pt-4 space-y-4">
        <BackButton fallback="/app/me" label="Back"/>
        <div className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-5">
          <p className="text-xs uppercase tracking-[0.2em] text-[#DC2626]">Your reach</p>
          <h1 className="font-display text-2xl font-bold mt-1">Numbers that tell your story</h1>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {cards.map((c) => (
            <div key={c.label} data-testid={`stat-${c.label.toLowerCase().replace(/\s/g,'-')}`} className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-4">
              <div className={`w-9 h-9 rounded-lg bg-zinc-900 border border-zinc-700 flex items-center justify-center ${c.color}`}>
                <c.icon size={16}/>
              </div>
              <p className="mt-3 font-display text-3xl font-bold text-white">{c.value.toLocaleString()}</p>
              <p className="text-xs text-zinc-400 mt-0.5">{c.label}</p>
            </div>
          ))}
        </div>

        <div className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-5">
          <p className="font-display text-lg font-semibold mb-3">Top performances</p>
          {data.top_videos?.length ? (
            <div className="space-y-2">
              {data.top_videos.map((v) => (
                <Link key={v.id} to={`/v/${v.id}`} className="flex items-center justify-between rounded-xl border border-zinc-800 bg-zinc-900/40 p-3 hover:border-[#DC2626]/40 transition-colors">
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-white truncate">{v.title || "Untitled"}</p>
                    <p className="text-xs text-zinc-400 mt-0.5">{v.duration}s</p>
                  </div>
                  <div className="text-right shrink-0 ml-3">
                    <p className="text-sm text-white">{v.views} views</p>
                    <p className="text-xs text-zinc-400">{v.likes} likes</p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="text-sm text-zinc-400">Upload your first performance to start collecting stats.</p>
          )}
        </div>
      </div>
    </div>
  );
}
